// Generated by purs version 0.14.4
import * as Restaumatic_I18n_TranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
var t = Restaumatic_I18n_TranslationKeys.unsafeMakeTranslationKeysProxy("");
export {
    t
};
//# sourceMappingURL=index.js.map
